// Actions
import {
  SET_MAP_REF,
  CLEAR_MAP_REF,
  SET_MAP_ZOOM,
  FIT_MAP_BOUNDS,
  FLY_TO,
  SET_VIEW,
} from './constants'

// Utils
import createActionCreator from 'fc-utils/createAction'

// Exports
export const setMapRef = createActionCreator(SET_MAP_REF)
export const clearMapRef = createActionCreator(CLEAR_MAP_REF)
export const setMapZoom = createActionCreator(SET_MAP_ZOOM)
export const fitMapBounds = createActionCreator(FIT_MAP_BOUNDS)
export const flyTo = createActionCreator(FLY_TO)
export const setView = createActionCreator(SET_VIEW)
